
<div class="flex flex-row justify-between my-8 mx-4">
  <div class="flex flex-row  justify-start gap-3" >
    <div class="text-xl text-black-dark-light">
      Home
    </div>
    <div class="text-xl font-black text-black-dark-light">
      /
    </div>
    <div class="text-xl text-black-dark-light text-orange-600">
      <span *ngIf="ticketFilter.assignedToMe == null && ticketFilter.raisedByMe == null && ticketFilter.taggedIn == null && ticketFilter.assignedTeamName == null && ticketFilter.assignedUserName == null;">Issues</span>
      <span *ngIf="ticketFilter.raisedByMe">Issues Raised By Me</span>
      <span *ngIf="ticketFilter.assignedToMe">Issues Assigned To Me</span>
      <span *ngIf="ticketFilter.taggedIn">Issues I am Tagged In</span>
      <span *ngIf="ticketFilter.assignedTeamName">{{ticketFilter.assignedTeamName}}</span>
      <span *ngIf="ticketFilter.assignedUserName">{{ticketFilter.assignedUserName}}</span>
    </div>
  </div>


    <button  class="btn btn-dlight flex-grow-0 gap-2" (click)="openNewTicketModal(newTicketModal)">
      New Ticket
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 1.6 1.6" xml:space="preserve"><path d="M1.425.45C1.387.488 1.357.5 1.3.5a.194.194 0 0 1-.2-.2c0-.057.012-.087.05-.125L1 .025.025 1l.15.15C.213 1.112.243 1.1.3 1.1c.115 0 .2.085.2.2 0 .057-.012.087-.05.125l.15.15L1.575.6zM.65.375l.1.1m.375.375.1.1M.8.525l.1.1M.975.7l.1.1" fill="none" stroke="white" stroke-width=".1" stroke-miterlimit="10"/></svg>
    </button>

</div>

<!--  table begin -->




  <div class="bg-white ticket-table" style="border-radius:20px" >

    <div class="flex flex-row justify-between p-5">
      <div class="flex flex-row justify-start  gap-3 ">

        <input *ngIf="can('can-manage-ticket-assignees')" type="checkbox" class="form-checkbox my-auto h-4" [(ngModel)]="selectedAllTickets" [ngModelOptions]="{standalone: true}" [disabled]="!tickets.length > 0"  (click)="$event.stopPropagation();changeAllTicketsSelection($event.target.checked)" />

        <div class="my-auto">
          <svg fill="#949aa0" width="32px" height="32px" viewBox="-0.08 -0.08 0.96 0.96" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-filter"><path d="m0.083 0.08 0.259 0.324A0.08 0.08 0 0 1 0.36 0.454V0.72l0.08 -0.06v-0.206a0.08 0.08 0 0 1 0.018 -0.05L0.717 0.08zm0 -0.08h0.634a0.08 0.08 0 0 1 0.062 0.13L0.52 0.454v0.206a0.08 0.08 0 0 1 -0.032 0.064l-0.08 0.06A0.08 0.08 0 0 1 0.28 0.72v-0.266L0.021 0.13A0.08 0.08 0 0 1 0.083 0"/></svg>
        </div>
        <div class="my-auto" style="color:#949aa0">Filter</div>
        <div class="my-auto">
          <select class="select_input form-input form-input-focus " placeholder="Priority"  [(ngModel)]="ticketFilter.ticketPriorityId" name="ticketPriorityId">
            <option [value]="priority.id" *ngFor="let priority of priorities"> {{priority.name}} </option>
          </select>
        </div>


        <div class="my-auto" >

          <select class="select_input form-input form-input-focus " placeholder="Request Type" [(ngModel)]="ticketFilter.requestTypeId" name="requestType">

            <option [value]="requestType.id" *ngFor="let requestType of requestTypes"> {{requestType.name}} </option>
          </select>
        </div>


        <div class="my-auto" *ngIf="can('can-filter-tickets-by-assigned-user')">
          <div   class="dropdown" style="position:relative">
            <input  type="text" (click)="showUserDropdown=true"  (keyup)="searchUsers()" [(ngModel)]="userSearch" name="userSearch" class="form-input form-input-focus" >



            <div class="relative">
                <div  *ngIf="showUserDropdown" class="box-shadow-pop" style="border-radius:10px;position:absolute;z-index:999;top:0px;width:300px;min-height:30px;background-color: white">
                  <div class="mt-5 mb-5" *ngIf="loadingUserSearch">
                    <div class="flex flex-row justify-center w-full  gap-4">
                      <span class="m-auto mb-10 inline-block h-14 w-14 animate-spin rounded-full border-8 border-[#f1f2f3] border-l-dlight align-middle"></span>
                    </div>
                  </div>
                  <ng-container *ngIf="!loadingUserSearch">

                     <span (click)="filterUnassignedTickets()" *ngIf="userSearchResults.length == 0"  style="padding:3px;padding-left:8px;padding-right:8px;padding-top:8px;padding-bottom:8px" class=" cursor-pointer ease-in-out duration-300 hover:bg-gray-100 flex p-1 items-center gap-3 justify-start rounded-lg  object-cover text-center  ">
                      <svg width="21" height="21" viewBox="0 0 0.945 0.945" xmlns="http://www.w3.org/2000/svg" class="ng-tns-c2641214630-1"><path d="M.473.446A.184.184 0 1 0 .289.262a.185.185 0 0 0 .184.184m0-.315a.131.131 0 1 1-.131.131.13.13 0 0 1 .131-.131" class="clr-i-outline clr-i-outline-path-1 ng-tns-c2641214630-1"/><path d="M.799.64a.45.45 0 0 0-.655 0A.05.05 0 0 0 .13.676v.138a.053.053 0 0 0 .053.053h.578A.053.053 0 0 0 .815.814V.676A.05.05 0 0 0 .802.64M.761.814H.184V.676a.395.395 0 0 1 .578 0Z" class="clr-i-outline clr-i-outline-path-2 ng-tns-c2641214630-1"/><path d="M0 0h.945v.945H0z" fill="none" class="ng-tns-c2641214630-1"/></svg>
                        <span  >
                        Not Assigned
                      </span>
                      </span>

                  <div (click)="selectUser(user)" *ngFor="let user of userSearchResults" style="padding:3px;padding-right:6px; border-radius:20px"
                       class="cursor-pointer ease-in-out duration-300 hover:bg-gray-100 flex flex-row items-center justify-start gap-3">
                      <span  class="flex h-8 w-8 items-center justify-center rounded-full bg-primary object-cover text-center text-base text-white"
                             [ngStyle]="{'background':user.colorCode}">
                        {{user.initials}}
                      </span>
                      <span  >
                            {{user.name}}
                      </span>
                  </div>
                  </ng-container>
                </div>
            </div>


          </div>
        </div>

        <div class="my-auto" >

          <select class="select_input form-input form-input-focus " placeholder="Region" [(ngModel)]="ticketFilter.adminZoneId" name="adminZoneId">

            <option [value]="adminZone.id" *ngFor="let adminZone of adminZones"> {{adminZone.name}} </option>
          </select>
        </div>

      </div>

      <div>
        <div class="flex flex-row justify-start">
          <div>
            <input [(ngModel)]="ticketFilter.query" name="ticketFilterQuery" id="addonsLeft" type="text" placeholder="Search Tickets" class="form-input rounded-r-none form-input-focus" />
          </div>
          <button (click)="changeFilter()" type="button" class="btn btn-dlight rounded-l-none gap-3">
            Search
            <svg width="20" height="20" viewBox="0 0 0.375 0.375" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m.363.363-.1-.1m-.1.05a.15.15 0 1 1 0-.3.15.15 0 0 1 0 .3Z" stroke="currentColor" stroke-width=".025"/></svg>
          </button>

        </div>
      </div>
    </div>

    <div class="grid grid-cols-10 py-3 pl-5 pr-3 ticket-row">
      <div class="col-span-1 my-auto">
        TICKET NUMBER
      </div>
      <div class="col-span-1 my-auto">
        CUSTOMER
      </div>
      <div class="col-span-1 my-auto">
        PRIORITY
      </div>
      <div class="col-span-1 my-auto">
        ISSUE TYPE
      </div>
      <div class="col-span-1 my-auto">
        DATE
      </div>
      <div class="col-span-1 my-auto">
        STATUS
      </div>
      <div class="col-span-1 my-auto">
        REGION
      </div>
      <div class="col-span-1 my-auto">
        SLA <span class="text-sm">(Response Time)</span>
      </div>
      <div class="col-span-1 my-auto">
        SLA <span class="text-sm">(Resolution Time)</span>
      </div>
      <div class="col-span-1 my-auto">
        ASSIGNED TO
      </div>

    </div>
    <div class="mt-5 mb-5" *ngIf="loadingTable">
      <div class="flex flex-row justify-center w-full  gap-4">
        <span class="m-auto mb-10 inline-block h-14 w-14 animate-spin rounded-full border-8 border-[#f1f2f3] border-l-dlight align-middle"></span>
      </div>
    </div>
    <ng-container *ngIf="!loadingTable">
    <div  class="grid grid-cols-10 py-3 ticket-row cursor-pointer pl-5 pr-3 gap-1" *ngFor="let ticket of tickets"  (click)="openViewTicketModal(viewTicketModal, ticket.id)">
      <div class="col-span-1 my-auto  text-black flex flex-row justify-start items-center gap-2">
        <input *ngIf="can('can-manage-ticket-assignees')" type="checkbox" class="form-checkbox h-4" [(ngModel)]="ticket.selected" (click)="selectTicket(ticket.id, $event.target.checked)" [ngModelOptions]="{standalone: true}"  (click)="$event.stopPropagation()" />
        <div>
          {{ticket.ticketNumber}}
        </div>
      </div>
      <div class="col-span-1 my-auto text-black">
        {{ticket.customer}}
      </div>
      <div class="col-span-1 my-auto pl-1 justify-center">
        <div *ngIf="ticket.priority && ticket.priority.includes('High')">
          <span class="badge bg-danger rounded-full">High</span>
        </div>
        <div *ngIf="ticket.priority && ticket.priority.includes('Medium')">
          <span class="badge bg-warning rounded-full">Medium</span>
        </div>
        <div *ngIf="ticket.priority && ticket.priority.includes('Low')">
          <span class="badge bg-success rounded-full">Low</span>
        </div>
      </div>
      <div class="col-span-1 my-auto text-black-50">
        {{ticket.issueType}}
      </div>

      <div class="col-span-1 my-auto flex flex-col text-black-50">
        <div>
          {{ moment(ticket.date).format('DD MMMM YYYY') }}
        </div>
        <div class="text-gray-400">
          {{ moment(ticket.date).format('HH:mm') }}
        </div>
      </div>

      <div class="col-span-1 my-auto justify-center">
        <div>
          <span class="badge rounded-full"  [ngStyle]="{'background-color': ticket.ticketStatusColorCode, 'color' : ticket.ticketStatusTextColor}">{{ticket.status}}</span>
        </div>
      </div>

      <div class="col-span-1 my-auto text-black-50">
        {{ticket.countryAdminZoneName}}
      </div>

      <div class="col-span-1 my-auto justify-center pl-1 cursor-pointer font-medium text-sm">
        <div *ngIf="ticket.firstResponseSlaGood == true"  class="text-success">
          <span  [tooltip]="'SLA met at ' +  moment(ticket.firstResponseSlaDate).format('DD MMMM YYYY, HH:mm') ">
            {{ticket.firstResponseSlaText}}
          </span>
        </div>
        <div *ngIf="ticket.firstResponseSlaGood == false" class="text-danger">
          <span  [tooltip]="'SLA expired at ' +  moment(ticket.firstResponseSlaEta).format('DD MMMM YYYY, HH:mm') " >
            {{ticket.firstResponseSlaText}}
          </span>
        </div>
        <div *ngIf="ticket.firstResponseSlaGood == null" >
          <span [tooltip]="'SLA open, expires at ' + moment(ticket.firstResponseSlaEta).format('DD MMMM YYYY, HH:mm') ">
            {{ticket.firstResponseSlaText}}
          </span>
        </div>
      </div>

      <div class="col-span-1 my-auto justify-center pl-1 cursor-pointer font-medium text-sm">
        <div *ngIf="ticket.resolutionStatusSlaGood == true"   class="text-success">
          <span [tooltip]="'SLA met at ' +  moment(ticket.resolutionStatusSlaDate).format('DD MMMM YYYY, HH:mm') ">
            {{ticket.resolutionStatusSlaText}}
          </span>
        </div>
        <div *ngIf="ticket.resolutionStatusSlaGood == false"  class="text-danger">
          <span [tooltip]="'SLA expired at ' +  moment(ticket.resolutionStatusSlaEta).format('DD MMMM YYYY, HH:mm') ">
            {{ticket.resolutionStatusSlaText}}
          </span>
        </div>
        <div *ngIf="ticket.resolutionStatusSlaGood == null" >
          <span [tooltip]="'SLA open, expires at ' + moment(ticket.resolutionStatusSlaEta).format('DD MMMM YYYY, HH:mm')">
            {{ticket.resolutionStatusSlaText}}
          </span>
        </div>
      </div>

      <div (click)="$event.stopPropagation()" class="col-span-1 my-auto justify-center">
        <div *ngIf="ticket.assignedName != null " style="padding:3px;padding-right:1px;border:1px dashed #D2D2D2; border-radius:20px" class="cursor-pointer ease-in-out duration-300 hover:bg-gray-100 grid grid-cols-4 items-center justify-start gap-1">
          <span  class=" col-span-1 flex h-8 w-8 items-center justify-center rounded-full bg-primary object-cover text-center text-base text-white"
                [ngStyle]="{'background':ticket.assignedColorCode}">
            {{ticket.assignedInitials}}
            <svg *ngIf="ticket.assignedRepairCentreId != null"  xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 12 12" xml:space="preserve" width="12" height="12"><path d="M10.967.777a.86.86 0 0 0-.608-.245c-.262 0-.526.111-.729.303l-.87.705-.033.031a.82.82 0 0 0-.221.735l-2.029 1.97-.34-.295c.243-.954.213-2.225-.609-3.048C4.925.333 4.155 0 3.357 0a2.8 2.8 0 0 0-.93.158.442.442 0 0 0-.195.705l1.094 1.306-.054.84-.909.104-1.298-1.085a.444.444 0 0 0-.705.195c-.353 1.023-.041 2.125.857 3.022.483.484 1.181.741 2.015.741q.093-.002.183-.006-.046.039-.092.082L.833 8.553a1.78 1.78 0 0 0 0 2.51l.417.417c.335.335.781.519 1.255.519s.92-.184 1.255-.519l2.492-2.493a1.7 1.7 0 0 0 .328-.459l2.213 2.558.021.023c.249.249.621.385 1.048.385.52 0 1.049-.205 1.378-.535.579-.579.763-1.815.149-2.427l-.023-.021-3.222-2.788 1.859-1.915q.076.014.153.014a.8.8 0 0 0 .579-.234l.736-.903c.169-.177.273-.399.298-.628a.87.87 0 0 0-.24-.708zM5.625 8.361l-2.492 2.493a.883.883 0 0 1-1.254 0l-.417-.417a.883.883 0 0 1 0-1.255l2.493-2.493a.87.87 0 0 1 .831-.236l1.101 1.27a.88.88 0 0 1-.258.638m4.991 1.971c-.165.165-.466.274-.753.274-.179 0-.333-.044-.412-.117L4.749 5.057a.45.45 0 0 0-.477-.129 3.3 3.3 0 0 1-1.04.171c-.585 0-1.077-.171-1.389-.481-.28-.28-.675-.777-.733-1.395l.826.692a.45.45 0 0 0 .335.1l1.467-.167a.44.44 0 0 0 .393-.412l.088-1.388a.45.45 0 0 0-.103-.313L3.408.888c.542.015 1.069.253 1.491.675.579.579.567 1.665.309 2.427a.45.45 0 0 0 .129.477l5.434 4.703c.197.216.151.855-.159 1.163m.215-8.259-.696.854-.024-.012-.302-.178-2.334 2.403-.327-.282 2.43-2.356-.178-.301-.012-.025.819-.665.033-.031a.2.2 0 0 1 .117-.062l.539.539a.2.2 0 0 1-.063.116"/></svg>
          </span>
          <span [tooltip]="ticket.assignedName"  class="text-sm col-span-3 assignee-box">
            {{ticket.assignedName}}
          </span>
        </div>

        <span *ngIf="ticket.assignedName == null" style="padding:3px;padding-left:8px;padding-right:8px;border:1px dashed #D2D2D2; border-radius:20px;padding-top:5px;padding-bottom:5px" class=" cursor ease-in-out duration-300 hover:bg-gray-100 flex p-1 items-center gap-1 justify-center rounded-lg  object-cover text-center  ">
          <svg width="21" height="21" viewBox="0 0 0.945 0.945" xmlns="http://www.w3.org/2000/svg" class="ng-tns-c2641214630-1"><path d="M.473.446A.184.184 0 1 0 .289.262a.185.185 0 0 0 .184.184m0-.315a.131.131 0 1 1-.131.131.13.13 0 0 1 .131-.131" class="clr-i-outline clr-i-outline-path-1 ng-tns-c2641214630-1"/><path d="M.799.64a.45.45 0 0 0-.655 0A.05.05 0 0 0 .13.676v.138a.053.053 0 0 0 .053.053h.578A.053.053 0 0 0 .815.814V.676A.05.05 0 0 0 .802.64M.761.814H.184V.676a.395.395 0 0 1 .578 0Z" class="clr-i-outline clr-i-outline-path-2 ng-tns-c2641214630-1"/><path d="M0 0h.945v.945H0z" fill="none" class="ng-tns-c2641214630-1"/></svg>
            <span  >
            Not Assigned
          </span>
        </span>
      </div>



    </div>
    </ng-container>



    <div class="flex flex-row justify-end mr-3 py-3">
      <ul class="inline-flex items-center space-x-1 rtl:space-x-reverse">
        <li *ngIf="ticketFilter.page >=1" ><button (click)="filterPage(ticketFilter.page - 1 )" type="button" class="btn btn-outline-dlight" style="border-radius:10px" >Prev</button></li>
        <li *ngIf="ticketFilter.page >=1"><button (click)="filterPage(ticketFilter.page - 1 )" type="button" class="btn btn-outline-dlight" style="border-radius:10px" >{{ticketFilter.page  }}</button></li>
        <li><button type="button" class="btn btn-dlight" style="border-radius:10px" >{{ticketFilter.page + 1}}</button></li>
        <li *ngIf="!ticketFilter.last"><button (click)="filterPage(ticketFilter.page +1)" type="button" class="btn btn-outline-dlight" style="border-radius:10px" >{{ticketFilter.page + 2 }}</button></li>
        <li *ngIf="!ticketFilter.last"><button (click)="filterPage(ticketFilter.page + 1)" type="button" class="btn btn-outline-dlight" style="border-radius:10px" >Next</button></li>
      </ul>
    </div>

  </div>

<div class="flex flex-row w-full justify-start">
  <div class="flex flex-row w-80 ml-6 mt-3">

    <button *ngIf="selectedTickets.length > 0"  class="btn btn-info flex-grow-0 gap-2 mt-1" (click)="openReassignTicketsModal(reassignTicketsModal)">
      Reassign Tickets
      <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 20 20" width="20" height="20"><path d="M18 12.711a5.2 5.2 0 0 0 -0.912 -2.942 5.2 5.2 0 0 0 -1.623 -1.533 3.9 3.9 0 0 0 1.227 -2.841 3.92 3.92 0 0 0 -3.915 -3.915 3.93 3.93 0 0 0 -3.208 1.672 4 4 0 0 0 -1.134 0A3.93 3.93 0 0 0 5.227 1.48a3.92 3.92 0 0 0 -3.915 3.915c0 1.119 0.471 2.127 1.227 2.841A5.2 5.2 0 0 0 0.916 9.769 5.2 5.2 0 0 0 0 12.711v2.178h3.776v1.631h10.449v-1.631H18zM12.775 2.445c1.627 0 2.949 1.323 2.949 2.949s-1.323 2.949 -2.949 2.949l-0.087 -0.002 0.006 -0.019a3.4 3.4 0 0 0 0.126 -0.439l0.008 -0.032q0.013 -0.06 0.024 -0.123l0.01 -0.057a3 3 0 0 0 0.027 -0.187 4 4 0 0 0 0.018 -0.198l0.005 -0.08 0.004 -0.171v-0.017a3 3 0 0 0 -0.004 -0.174l-0.003 -0.051 -0.011 -0.147 -0.003 -0.033a3.9 3.9 0 0 0 -2.325 -3.178 2.97 2.97 0 0 1 2.205 -0.993M7.977 4.259l0.028 -0.009a3 3 0 0 1 0.207 -0.065 3 3 0 0 1 0.785 -0.107 3 3 0 0 1 0.837 0.122l0.068 0.021 0.09 0.031 0.027 0.009a2.97 2.97 0 0 1 1.893 2.307l0.003 0.026q0.009 0.054 0.014 0.109l0.004 0.04 0.008 0.1 0.003 0.044q0.003 0.064 0.003 0.129v0.016q0 0.063 -0.003 0.125l-0.003 0.039 -0.009 0.12 -0.005 0.045 -0.009 0.077q-0.003 0.03 -0.009 0.059a3 3 0 0 1 -0.044 0.217l-0.031 0.117 -0.014 0.046 -0.021 0.066 -0.018 0.052 -0.021 0.059 -0.039 0.099 -0.019 0.045 -0.037 0.081 -0.004 0.009 -0.014 0.028 -0.045 0.087 -0.018 0.033 -0.002 0.003 -0.051 0.09 -0.021 0.035q-0.029 0.047 -0.06 0.093l-0.039 0.057 -0.033 0.047 -0.077 0.1q-0.024 0.031 -0.05 0.06l-0.032 0.037 -0.052 0.059 -0.033 0.033 -0.089 0.09 -0.055 0.051 -0.039 0.034 -0.098 0.083q-0.039 0.033 -0.08 0.063l-0.021 0.016a2.94 2.94 0 0 1 -3.513 0l-0.021 -0.016 -0.081 -0.063 -0.033 -0.027 -0.064 -0.056 -0.039 -0.034 -0.055 -0.051 -0.089 -0.091 -0.033 -0.033 -0.052 -0.059 -0.032 -0.037 -0.081 -0.1 -0.045 -0.06 -0.033 -0.047 -0.039 -0.057 -0.06 -0.093 -0.021 -0.034 -0.052 -0.092 -0.018 -0.034 -0.045 -0.087 -0.015 -0.032 -0.003 -0.004 -0.039 -0.086 -0.018 -0.041 -0.04 -0.102 -0.02 -0.056 -0.02 -0.057 -0.021 -0.063 -0.027 -0.094 -0.016 -0.068 -0.012 -0.053 -0.015 -0.065 -0.018 -0.103 -0.009 -0.056 -0.01 -0.083 -0.004 -0.041 -0.009 -0.123 -0.002 -0.035 -0.003 -0.133q0 -0.072 0.003 -0.141l0.003 -0.039 0.009 -0.105 0.003 -0.037q0.006 -0.057 0.015 -0.113l0.003 -0.021a2.96 2.96 0 0 1 1.893 -2.309m-5.698 1.14a2.953 2.953 0 0 1 2.949 -2.949c0.849 0 1.651 0.369 2.205 0.993a3.9 3.9 0 0 0 -2.325 3.18l-0.003 0.028 -0.011 0.152 -0.003 0.046a3 3 0 0 0 -0.004 0.183 3 3 0 0 0 0.009 0.258l0.009 0.105 0.01 0.093a3 3 0 0 0 0.027 0.188l0.011 0.063 0.023 0.117 0.009 0.039a3 3 0 0 0 0.123 0.426l0.009 0.027 -0.087 0.002a2.955 2.955 0 0 1 -2.949 -2.949m2.31 6.161 -0.032 0.051 -0.065 0.107 -0.034 0.061 -0.09 0.165 -0.051 0.101 -0.032 0.064 -0.05 0.108 -0.027 0.059 -0.055 0.13 -0.015 0.039 -0.063 0.171 -0.014 0.039 -0.045 0.134 -0.019 0.062 -0.033 0.114 -0.018 0.069 -0.027 0.111 -0.039 0.183 -0.014 0.068 -0.021 0.123 -0.009 0.057 -0.024 0.182v0.003q-0.009 0.083 -0.015 0.166H0.967v-1.212A4.25 4.25 0 0 1 3.41 8.865a3.9 3.9 0 0 0 1.815 0.447q0.285 0 0.567 -0.042l0.09 0.123 0.033 0.04 0.093 0.116 0.039 0.045a3 3 0 0 0 0.141 0.153l0.087 0.087 0.033 0.033 -0.124 0.078 -0.021 0.014 -0.123 0.081 -0.04 0.031 -0.107 0.077 -0.033 0.025q-0.068 0.051 -0.134 0.105l-0.028 0.023 -0.143 0.122 -0.101 0.092 -0.027 0.024 -0.121 0.117 -0.031 0.032 -0.09 0.094 -0.035 0.039q-0.051 0.055 -0.099 0.111l-0.015 0.017q-0.056 0.064 -0.109 0.131l-0.029 0.038 -0.08 0.104 -0.03 0.04 -0.1 0.141 -0.102 0.155m0.156 3.998V14.34q0 -0.081 0.003 -0.16l0.003 -0.052 0.006 -0.106 0.006 -0.064 0.009 -0.093 0.009 -0.069 0.012 -0.088 0.012 -0.069 0.015 -0.085 0.015 -0.071 0.034 -0.153 0.02 -0.08 0.021 -0.071 0.022 -0.078 0.023 -0.071 0.025 -0.075 0.026 -0.07 0.027 -0.075 0.028 -0.069 0.03 -0.073 0.031 -0.069 0.033 -0.071 0.033 -0.069 0.034 -0.069 0.036 -0.068 0.037 -0.068 0.039 -0.066 0.039 -0.066 0.041 -0.064 0.042 -0.064 0.044 -0.063 0.045 -0.063 0.045 -0.063 0.045 -0.061 0.048 -0.061 0.048 -0.059 0.051 -0.058 0.051 -0.057 0.052 -0.057 0.052 -0.057 0.054 -0.055 0.055 -0.054 0.057 -0.053 0.057 -0.052 0.058 -0.051 0.059 -0.051 0.06 -0.049 0.062 -0.049 0.125 -0.093a4 4 0 0 1 0.195 -0.131l0.135 -0.082a4 4 0 0 1 0.211 -0.116l0.069 -0.035 0.056 -0.027a3.9 3.9 0 0 0 1.815 0.447 3.9 3.9 0 0 0 1.815 -0.447l0.055 0.027 0.141 0.073 0.138 0.077 0.135 0.082 0.131 0.087 0.064 0.045 0.063 0.045 0.123 0.095 0.061 0.05 0.059 0.051 0.116 0.104 0.057 0.053 0.055 0.054 0.055 0.056 0.052 0.056 0.052 0.057 0.051 0.057 0.051 0.059 0.048 0.059q0.025 0.03 0.048 0.061a3 3 0 0 1 0.135 0.185l0.044 0.063 0.041 0.064 0.041 0.065 0.039 0.066 0.039 0.067 0.037 0.068 0.036 0.068 0.034 0.069 0.033 0.069 0.033 0.071 0.031 0.069 0.03 0.072 0.028 0.07 0.027 0.075 0.026 0.071 0.025 0.075 0.023 0.071 0.022 0.078 0.021 0.071 0.02 0.08 0.017 0.071 0.017 0.081 0.015 0.071 0.015 0.084 0.012 0.07 0.011 0.087 0.009 0.069 0.009 0.093 0.006 0.064 0.006 0.106 0.003 0.052q0.003 0.081 0.003 0.16v1.212zm9.466 -1.631a5 5 0 0 0 -0.04 -0.351l-0.009 -0.055q-0.009 -0.063 -0.021 -0.126l-0.013 -0.066 -0.024 -0.114a5 5 0 0 0 -0.062 -0.248l-0.033 -0.116 -0.018 -0.061 -0.045 -0.135 -0.013 -0.038 -0.064 -0.172 -0.015 -0.037 -0.056 -0.133 -0.027 -0.057 -0.051 -0.109 -0.031 -0.063 -0.086 -0.165 -0.057 -0.101 -0.034 -0.061 -0.065 -0.108 -0.031 -0.051 -0.102 -0.155 -0.1 -0.141 -0.03 -0.039 -0.08 -0.104 -0.029 -0.037q-0.053 -0.067 -0.109 -0.132l-0.015 -0.016a5 5 0 0 0 -0.225 -0.244l-0.03 -0.031 -0.122 -0.117 -0.026 -0.024 -0.102 -0.093 -0.039 -0.034 -0.104 -0.087 -0.028 -0.023 -0.133 -0.105 -0.033 -0.025a5 5 0 0 0 -0.27 -0.188l-0.021 -0.015 -0.124 -0.078 0.032 -0.032 0.088 -0.088a3 3 0 0 0 0.141 -0.153l0.039 -0.045 0.095 -0.117 0.031 -0.039 0.091 -0.124q0.284 0.042 0.567 0.042a3.9 3.9 0 0 0 1.815 -0.447 4.25 4.25 0 0 1 2.443 3.849v1.212z"/></svg>
    </button>
  </div>
</div>


<ng-template #newTicketModal>


  <ticket-create (outputCloseEvent)="closeNewTicketModal($event)" ></ticket-create>


</ng-template>


<ng-template #viewTicketModal>

  <ticket-view (outputOpenCustomerEvent)="openCustomerPage($event)" (outputOpenTicketEvent)="openTicketPage($event)" (closeEvent)="closeViewModal()" [setNotesEditable]="false"  [ticketId]="selectedTicketId"></ticket-view>

</ng-template>

<ng-template #reassignTicketsModal>

  <div class="modal-header" style="border-bottom:1px solid rgb(235,235,235)">
    <div  class="ticket-header flex flex-row justify-start gap-3 items-center ease-in-out duration-300 cursor-pointer badge bg-success rounded-xl text-xl font-bold" style="background-color: #fbd9d4; color: #ed6754;">
      <span >Reassign Tickets</span>
    </div>
  </div>

  <div class="mt-3 font-bold text-lg pl-4">
    Tickets
  </div>
  <div >

    <div class="grid grid-cols-3 gap-3 w-8/10 m-auto pl-4 mt-5 pb-8">
      <div class="flex flex-col justify-between">
        <div class="font-semibold">
          Assignee
        </div>

        <div style="position:relative">
          <input  type="text"  (keyup)="searchUsers()" [(ngModel)]="userSearch" name="userSearch" class="form-input form-input-focus" >
          <div  *ngIf="showUserDropdown" class="box-shadow-pop" style="border-radius:10px;position:absolute;z-index:999;top:40px;width:300px;min-height:30px;background-color: white">
            <div class="mt-5 mb-5" *ngIf="loadingUserSearch">
              <div class="flex flex-row justify-center w-full  gap-4">
                <span class="m-auto mb-10 inline-block h-14 w-14 animate-spin rounded-full border-8 border-[#f1f2f3] border-l-dlight align-middle"></span>
              </div>
            </div>
            <ng-container *ngIf="!loadingUserSearch">
              <div (click)="selectAssignTarget(user)" *ngFor="let user of userSearchResults" style="padding:3px;padding-right:6px; border-radius:20px"
                   class="grid grid-cols-5 cursor-pointer ease-in-out duration-300 hover:bg-gray-100 flex flex-row items-center justify-start gap-3">
                  <span  class="col-span-1 flex h-8 w-8 items-center justify-center rounded-full bg-primary object-cover text-center text-base text-white"
                         [ngStyle]="{'background':user.colorCode}">
                    {{user.initials}}
                    <svg *ngIf="user.repairCentreId != null"  xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 12 12" xml:space="preserve" width="12" height="12"><path d="M10.967.777a.86.86 0 0 0-.608-.245c-.262 0-.526.111-.729.303l-.87.705-.033.031a.82.82 0 0 0-.221.735l-2.029 1.97-.34-.295c.243-.954.213-2.225-.609-3.048C4.925.333 4.155 0 3.357 0a2.8 2.8 0 0 0-.93.158.442.442 0 0 0-.195.705l1.094 1.306-.054.84-.909.104-1.298-1.085a.444.444 0 0 0-.705.195c-.353 1.023-.041 2.125.857 3.022.483.484 1.181.741 2.015.741q.093-.002.183-.006-.046.039-.092.082L.833 8.553a1.78 1.78 0 0 0 0 2.51l.417.417c.335.335.781.519 1.255.519s.92-.184 1.255-.519l2.492-2.493a1.7 1.7 0 0 0 .328-.459l2.213 2.558.021.023c.249.249.621.385 1.048.385.52 0 1.049-.205 1.378-.535.579-.579.763-1.815.149-2.427l-.023-.021-3.222-2.788 1.859-1.915q.076.014.153.014a.8.8 0 0 0 .579-.234l.736-.903c.169-.177.273-.399.298-.628a.87.87 0 0 0-.24-.708zM5.625 8.361l-2.492 2.493a.883.883 0 0 1-1.254 0l-.417-.417a.883.883 0 0 1 0-1.255l2.493-2.493a.87.87 0 0 1 .831-.236l1.101 1.27a.88.88 0 0 1-.258.638m4.991 1.971c-.165.165-.466.274-.753.274-.179 0-.333-.044-.412-.117L4.749 5.057a.45.45 0 0 0-.477-.129 3.3 3.3 0 0 1-1.04.171c-.585 0-1.077-.171-1.389-.481-.28-.28-.675-.777-.733-1.395l.826.692a.45.45 0 0 0 .335.1l1.467-.167a.44.44 0 0 0 .393-.412l.088-1.388a.45.45 0 0 0-.103-.313L3.408.888c.542.015 1.069.253 1.491.675.579.579.567 1.665.309 2.427a.45.45 0 0 0 .129.477l5.434 4.703c.197.216.151.855-.159 1.163m.215-8.259-.696.854-.024-.012-.302-.178-2.334 2.403-.327-.282 2.43-2.356-.178-.301-.012-.025.819-.665.033-.031a.2.2 0 0 1 .117-.062l.539.539a.2.2 0 0 1-.063.116"/></svg>
                  </span>
                <span  class="flex flex-row col-span-4 assignee-box">

                    {{user.name}} <span *ngIf="user.repairCentreLevel != null">{{' - (L' + user.repairCentreLevel + ')'}}</span>
                  </span>
              </div>
            </ng-container>
          </div>
        </div>



      </div>

      <div class="flex flex-col justify-between">
        <div class="font-semibold">
          Date Reassigned
        </div>
        <div>
          {{ moment(now).format('DD MMMM YYYY HH:mm') }}
        </div>
      </div>



      <div class="flex flex-col justify-between">
        <div class="font-semibold">
          Tickets Reassigned
        </div>
        <div>
          {{selectedTickets.length}}
        </div>
      </div>
    </div>
  </div>

  <div class="mt-3 flex flex-row justify-center gap-3 pr-3 pb-3" >
    <button class="btn btn-dlight flex-grow-0 gap-3"  (click)="reassignTicketsModalReference.hide()">
      Cancel
      <svg width="20" height="20" fill="white" viewBox="0 0 0.4 0.4" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M.2.025a.175.175 0 1 1 0 .35.175.175 0 0 1 0-.35M.075.2a.125.125 0 0 0 .194.104L.096.131A.13.13 0 0 0 .075.2M.2.075a.13.13 0 0 0-.069.021l.173.173A.125.125 0 0 0 .2.075"/></svg>
    </button>
    <button class="btn btn-success flex-grow-0 gap-3" (click)="bulkReassign()" >
      Reassign
      <svg width="20" height="20" viewBox="0 0 0.6 0.6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M.084.224a.19.19 0 0 1 .14-.14.3.3 0 0 1 .152 0 .19.19 0 0 1 .14.14.3.3 0 0 1 0 .152.19.19 0 0 1-.14.14.3.3 0 0 1-.152 0 .19.19 0 0 1-.14-.14.3.3 0 0 1 0-.152Z" stroke="white" stroke-width=".07"/><path d="m.231.294.05.05L.369.25" stroke="white" stroke-width=".07" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
  </div>

</ng-template>



